<template>
  <div class="navigator">
    <div class="country-selector">
      <div
        :class="[
          'country-selector-arrow',
          { disabled: selectedCountryIndex === 0 }
        ]"
        @click="previousCountry()"
      >
        <img
          :src="
            `${baseUrl}assets/images/atoms-icons-actions-navigation-chevron-left.svg`
          "
          alt="arrow left"
        />
      </div>
      <div class="country-selector-name">{{ getCountry }}</div>
      <div
        :class="[
          'country-selector-arrow',
          { disabled: selectedCountryIndex === countriesList.length - 1 }
        ]"
        @click="nextCountry()"
      >
        <img
          :src="
            `${baseUrl}assets/images/atoms-icons-actions-navigation-chevron-right.svg`
          "
          alt="arrow right"
        />
      </div>
    </div>
    <div class="country-viz">
      <div :class="['country-viz-shape', { detail: getPaint !== null }]">
        <div
          :class="[
            'country-viz-shape-item',
            { selected: selectedCountryIndex === countryIndex }
          ]"
          v-for="(country, countryIndex) in countriesList"
          :key="country.name"
          :style="{
            width:
              getPaint !== null &&
              selectedCountryIndex === countryIndex &&
              $tvaMq !== 'mobile' &&
              $tvaMq !== 'tablet'
                ? `${countries[getCountry].length * dotWidth}px`
                : `calc(${(100 / $ml.get('data').length) *
                    country.amount}% - 2px)`,
            marginRight: shapeItemMargin + 'px'
          }"
        >
          <template
            v-if="
              getPaint !== null &&
                selectedCountryIndex === countryIndex &&
                $tvaMq !== 'mobile' &&
                $tvaMq !== 'tablet'
            "
          >
            <div
              v-for="countryItem in countries[getCountry]"
              :key="countryItem.id"
              :class="[
                'country-viz-shape-item-dot',
                { selected: countryItem.id === getPaint.id }
              ]"
              :style="{ width: dotWidth + 'px', height: dotWidth + 'px' }"
            ></div>
          </template>
        </div>
        <div
          :class="[
            'country-viz-label',
            { left: computedLabelLeft <= 50, right: computedLabelLeft > 50 }
          ]"
          v-if="getPaint === null"
          :style="{
            left:
              computedLabelLeft <= 50
                ? `calc(${computedLabelLeft}% + ${shapeItemMargin}px)`
                : 'auto',
            right:
              computedLabelLeft > 50
                ? `calc(${computedLabelRight}% + ${shapeItemMargin *
                    (selectedCountryIndex === 10
                      ? -0.5
                      : selectedCountryIndex === 11
                      ? -3
                      : 1)}px)`
                : 'auto'
          }"
        >
          <span class="country-viz-label-selected">{{
            countriesList[selectedCountryIndex].amount
          }}</span>
          {{ $ml.get("content").navigation_label }}
          {{ $ml.get("data").length }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "navigator",
  data() {
    return {
      selectedCountryIndex: 0,
      shapeItemMargin: 2,
      dotWidth: 10,
      baseUrl: process.env.BASE_URL
    };
  },
  computed: {
    countries() {
      return _.groupBy(this.$ml.get("data"), d => d.country);
    },
    countriesList() {
      let res = [];
      _.forEach(this.countries, (country, countryKey) => {
        res.push({
          name: countryKey,
          amount: country.length,
          id: country[0].countryId
        });
      });
      res = res.sort((a, b) => b.amount - a.amount);
      return res;
    },
    computedLabelLeft() {
      let res = 0;
      _.forEach(this.countriesList, (country, countryIndex) => {
        if (countryIndex < this.selectedCountryIndex) {
          res = res + (100 / this.$ml.get("data").length) * country.amount;
        }
      });
      return res;
    },
    computedLabelRight() {
      let selectedCountryWidth =
        (100 / this.$ml.get("data").length) *
        this.countriesList[this.selectedCountryIndex].amount;

      return 100 - this.computedLabelLeft - selectedCountryWidth;
    },
    ...mapGetters(["getCountry", "getPaint"])
  },
  created() {
    this.setCountry(this.countriesList[this.selectedCountryIndex].name);
    this.setCountryId(this.countriesList[this.selectedCountryIndex].id);
  },
  watch: {
    selectedCountryIndex(value) {
      this.setCountry(this.countriesList[value].name);
      this.setCountryId(this.countriesList[value].id);
    },
    getPaint(paint) {
      if (paint !== null) {
        let index = _.findIndex(
          this.countriesList,
          country => country.name === this.getCountry
        );
        if (index !== this.selectedCountryIndex) {
          this.selectedCountryIndex = index;
        }
      }
    }
  },
  methods: {
    nextCountry() {
      this.selectedCountryIndex = this.selectedCountryIndex + 1;
      this.setCountry(this.countriesList[this.selectedCountryIndex].name);
      this.setCountryFirstPaint();
    },
    previousCountry() {
      this.selectedCountryIndex = this.selectedCountryIndex - 1;
      this.setCountry(this.countriesList[this.selectedCountryIndex].name);
      this.setCountryFirstPaint();
    },
    setCountryFirstPaint() {
      if (this.getPaint !== null) {
        this.setPaint(this.countries[this.getCountry][0]);
      }
    },
    ...mapActions(["setCountry", "setCountryId", "setPaint"])
  }
};
</script>

<style lang="scss" scoped>
.navigator {
  max-width: $max-width;
  width: 100%;
  margin: 0 auto;
  position: relative;
  pointer-events: none;
  * {
    user-select: none;
  }
  .country-selector {
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;

    &-arrow {
      cursor: pointer;
      pointer-events: initial;
      &.disabled {
        pointer-events: none;
        color: lightgrey;
      }
    }
    &-name {
      width: 100%;
      max-width: 190px;
      text-align: center;
      @include h3-desktop;
      @media (max-width: 500px) {
        max-width: 100px;
      }
    }
  }
  .country-viz {
    width: 100%;
    @media (max-width: 720px) {
      padding: 0 15px;
      width: calc(100% - 30px);
    }
    &-shape {
      position: relative;
      display: flex;

      &.detail {
        .country-viz-shape-item {
          flex-shrink: 1;
          background: rgba(255, 255, 255, 0.15);
          &.selected {
            background: rgba(255, 255, 255, 0.5);
            flex-shrink: 0;
          }
        }
      }
      &-item {
        height: 10px;
        min-width: 10px;
        border-radius: 5px;
        background: rgba(255, 255, 255, 0.3);
        display: flex;
        transition: all 0.3s ease;
        overflow: hidden;
        flex-shrink: 0;
        box-shadow: 0 2px 20px 0 $black, 0 2px 20px 0 rgba(0, 0, 0, 0.4);
        &.selected {
          background: rgba(255, 255, 255, 1);
        }
        &-dot {
          flex-shrink: 0;
          position: relative;

          &::after {
            content: "";
            position: absolute;
            top: 3px;
            left: 3px;
            background: #fff;
            border-radius: 50%;
            width: 4px;
            height: 4px;
            transition: all 0.3s ease;
          }
          &.selected {
            &::after {
              top: 0;
              left: 0;
              width: 10px;
              height: 10px;
            }
          }
        }
      }
    }
    &-label {
      position: absolute;
      bottom: -32px;
      transition: all 0.3s ease;
      background: #fff;
      padding: 2px 9px;
      white-space: nowrap;
      @include number-secondary_dark-left;
      &.left {
        left: 0;
        border-radius: 0 22.5px 22.5px 22.5px;
      }
      &.right {
        right: 0;
        border-radius: 22.5px 0 22.5px 22.5px;
      }
      .country-viz-label-selected {
        @include number-primary-left;
      }
    }
  }
}
</style>
